import { Stack, Typography } from "@mui/material";
import { theme } from "../../../layout/Theme";

export function SummaryField({ label, value }: { label: string; value: string | number }) {
  return (
    <Stack spacing={0.25}>
      <Typography variant="caption" color={theme.palette.neutral[500]} fontWeight={600}>
        {label}
      </Typography>
      <Typography variant="body2" color={theme.palette.neutral[700]}>
        {value}
      </Typography>
    </Stack>
  );
}
